<template>
  <div>
    <el-dialog  :close-on-click-modal="false" title="增加组织" :append-to-body="true" :visible.sync="addDialogVisible" class="imgbox" width="50%" :before-close="resetForm">
      <el-form resetFields label-width="80px" ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="组织名" prop="organizationName">
          <el-input v-model.trim="form.organizationName" autocomplete="off" placeholder="请输入组织名"></el-input>
        </el-form-item>
        <el-form-item label="组织编码" prop="organizationCode">
          <el-input v-model.trim="form.organizationCode" autocomplete="off" placeholder="请输入组织编码"></el-input>
        </el-form-item>
        <el-form-item label="组织类型" prop="organizationType">
          <el-radio-group v-model="form.organizationType">
            <el-radio :label="0">管理平台</el-radio>
            <el-radio :label="2">厂商</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" autocomplete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addOrg } from '@/api/organization'
import { regLn } from '@/assets/js/validator'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        organizationType: 0
      },
      rules: {
        organizationName: [
          { required: true, message: '组织名不能为空', trigger: 'blur' }
        ],
        organizationType: [
          { required: true, message: '请选择组织类型', trigger: 'change' }
        ],
        organizationCode: [
          { required: true, validator: regLn, trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  created () {

  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form)
          addOrg(params).then((res) => {
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.$emit('closeAddDialog', 1)
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeAddDialog')
    }
  }
}
</script>

<style lang='less' scoped>

</style>
